import type { z } from 'zod';

/**
 * Validador de campo do TanStack Form a partir de um schema Zod.
 *
 * Os form-fields base exibem `errors[0]` como texto. Com o schema no formulário
 * inteiro, o erro chega como objeto (issue do Zod) e quebra a renderização —
 * daí validar campo a campo, devolvendo só a mensagem em pt-BR do schema.
 */
export function zodFieldValidator<TValue>(schema: z.ZodType<TValue>) {
  return ({ value }: { value: TValue }): string | undefined => {
    const result = schema.safeParse(value);
    return result.success ? undefined : result.error.issues[0]?.message;
  };
}
